import styled from 'styled-components';
import { MOBILE_BREAKPOINT_IN_PX } from '../../constants';

const CardReaderButton = styled.a`
  cursor: pointer;
  touch-action: manipulation;

  &:hover {
    background-color: rgba(34, 34, 34, 0.3);
    @media screen and (max-width: ${MOBILE_BREAKPOINT_IN_PX}px) {
      background-color: transparent;
    }
  }
`;

export default CardReaderButton;
